import { Product } from '@framework/types';
import { FC } from 'react';
import { useTranslation } from '@i18n/client';

type ProductUnitLabelTranslationsProps = {
  product: Product;
  className: string;
};

export const ProductUnitLabelTranslations: FC<
  ProductUnitLabelTranslationsProps
> = ({ product, className }: ProductUnitLabelTranslationsProps) => {
  const { t } = useTranslation('not-used-text', 'common');

  return (
    <div className={className}>
      {t(`text-${product.unit?.toLowerCase() ?? 'stück'}`)}{' '}
      {product.items_per_unit != 1
        ? `(${product.items_per_unit} ${t('text-items')})`
        : ''}
    </div>
  );
};
